// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__aIzdO","colored":"Cell_colored__c58XS","hovered":"Cell_hovered__vfcXc"};